module.exports = __webpack_public_path__ + "static/media/003.fe0c5124.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/003.gif
// module id = 836
// module chunks = 0